/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from "@msdyn365-commerce/core";
import { createCaseAsync } from "../proxy/britax-claims-proxy/DataActionExtension.g";
import {
  ICaseWithAttachment,
  ICreateCaseResponse,
} from "../proxy/britax-claims-proxy/DataServiceEntities.g";
/**
 * BritaxPostCase Input Action
 */
var caseObject: ICaseWithAttachment;
export class BritaxPostCaseInput implements Msdyn365.IActionInput {
  // TODO: Construct the input needed to run the action
  constructor(caseO: any) {
    caseObject = caseO;
  }

  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `createCase`;
  public getCacheObjectType = () => "createCase";
  public dataCacheType = (): Msdyn365.CacheType => "none";
}
// TODO: Create a data model here or import one to capture the response of the action
export interface IBritaxPostCaseData {
  text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
  args: Msdyn365.ICreateActionContext
): Msdyn365.IActionInput => {
  return new BritaxPostCaseInput("");
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(
  input: BritaxPostCaseInput,
  ctx: Msdyn365.IActionContext
): Promise<ICreateCaseResponse | undefined> {
  // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
  if (caseObject) {
    const response = await createCaseAsync(
      { callerContext: ctx },
      caseObject
    ).catch((error) => {
      return {
        Success: false,
        Exception: error,
      };
    });

    return response;
  }
  return undefined;
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<ICreateCaseResponse>>action,
  // TODO: Give your data action a unique id
  id: "BritaxPostCase",
  input: createInput,
  // TODO: Uncomment the below line if this is a meant to be a batched data action
  // isBatched: true
});
